import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import CrumbBox from './widgets/CrumbBox'
import TransactionList from './widgets/TransactionList'
import agent from '../agent'
import { withRouter } from 'react-router-dom'
import Loading from './widgets/Loading'
import moment from 'moment'

import {
  TRANSACTION_DETAIL_LOADED,
  TRANSACTION_DETAIL_UNLOADED
} from '../constants/actionTypes'
const mapStateToProps = state => ({
  ...state.home,
  inProgress: state.common.inProgress
})

const mapDispatchToProps = dispatch => ({
  onLoad: (payload) => {
    dispatch({ type: TRANSACTION_DETAIL_LOADED, payload })
  },
  onUnload: () =>
    dispatch({ type: TRANSACTION_DETAIL_UNLOADED }),
})

class Transaction extends React.Component {
  componentWillMount() {
    const payload = Promise.all([
      agent.Common.getTransaction(this.props.match.params.address),
    ]);
    this.props.onLoad(payload);
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.match.params.address !== this.props.match.params.address) {
      const payload = Promise.all([
        agent.Common.getTransaction(nextProps.match.params.address),
      ]);
      this.props.onLoad(payload);
    }
  }
  componentWillUnmount() {
    this.props.onUnload();
  }

  render() {
    const inProgress = this.props.inProgress

    if (!inProgress && (!this.props.transaction)) {
      return (
        <div>
          <CrumbBox data={[{ key: 'Transaction' }]} rootKey='/transactions' rootVal='Transactions' />
          <div id="main">
            <div id="main-wrap">
              <div className="Delta">
                <h2>No Transaction Found</h2>
              </div>
            </div>
          </div>
        </div>
      )
    }
    const txn = this.props.transaction
    //const transactions_recent = this.props.transactions
    const txnOwner = (txn && txn.owner) ? txn.owner : ''
    const txnKey = (txn && txn.key) ? txn.key : ''
    const txnKeyDetail = (txn && txn.key) ? txn.key : 'loading...'
    const txnSender = (txn && txn.sender_account) ? txn.sender_account : ''
    const txnRecipient = (txn && txn.recipient_account) ? txn.recipient_account : ''
    const created = (txn && txn.created) ? moment(txn.created).format('LLLL') : ''  //.calendar()
    const txnAmount = (txn && txn.amount) ? txn.amount : ''
    const txnSymbol = (txn && txn.symbol) ? txn.symbol : ''
    const txnNotes = (txn && txn.notes) ? txn.notes : ''

    return (
      <div>
        <CrumbBox rootKey='/transactions' rootVal='Transactions' data={[{ key: 'Account', url: `/account/${txnOwner}` }, { key: `Transaction ${txnKey}` }]} />
        <div id="main"><div id="main-wrap">
          <div className="content">
            <h2>Transaction Detail</h2>
            <div className="FormItem">
              <label>TX Hash</label>
              <span>{txnKeyDetail}</span>
            </div>
            <div className="FormItem">
              <label>From</label>
              <span><Link className='address' to={`/account/${txnSender}`}>{txnSender}</Link></span>
            </div>
            <div className="FormItem">
              <label>To</label>
              <span><Link className='address' to={`/account/${txnRecipient}`}>{txnRecipient}</Link></span>
            </div>
            <div className="FormItem">
              <label>Created</label>
              <span>{created}</span>
            </div>
            <div className="FormItem">
              <label>Amount</label>
              <span>{txnAmount} {txnSymbol}</span>
            </div>
            <div className="FormItem">
              <label>Symbol</label>
              <span>{txnSymbol}</span>
            </div>
            {
              txnNotes ?
                <div className="FormItem">
                  <label>Notes</label>
                  <span>{txnNotes}</span>
                </div>
                : null
            }

          </div>
        </div></div>
      </div>
    )
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Transaction))
